import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen w-full flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="absolute bottom-4 select-none font-heading text-[6rem] font-black leading-none text-background-200 md:text-[10rem]">
        404
      </span>

      <div className="relative z-10 max-w-md">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
          <i className="ri-movie-2-line text-3xl" aria-hidden="true"></i>
        </span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          页面走丢了
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600">
          你访问的页面不存在或已被移除，返回首页继续浏览《出轨的妻子》高清影视资源与剧情介绍。
        </p>
        <p className="mt-2 font-label text-xs text-foreground-400">{location.pathname}</p>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-home-5-line" aria-hidden="true"></i>
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
          >
            <i className="ri-film-line" aria-hidden="true"></i>
            浏览电影分类
          </Link>
        </div>
      </div>
    </div>
  );
}